import { useDialog } from '@/common/dialog/DialogContext';
import { useFormFieldDef } from '@/common/form/hooks/useFormFieldDef';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon, IconButton, InputAdornment, TextField } from '@mui/material';
import { ProgProdFormulaDialog } from './ProgProdFormulaDialog';

export const ProgProdFormulaValue = ({ fieldDef }) => {
  const { value, helperText, onBlur, error, disabled, setValue } = useFormFieldDef(fieldDef);
  const { openDialog } = useDialog();

  const handleClick = () => {
    const data = { formula: value ?? '' };
    openDialog(ProgProdFormulaDialog, { data }).then((formula) => {
      onBlur();
      if (formula == null) return;
      setValue(formula);
    });
  };

  return (
    <TextField
      label={fieldDef.displayName}
      value={value ?? ''}
      onChange={(event) => setValue(event.target.value)}
      onBlur={onBlur}
      error={error}
      disabled={disabled}
      helperText={helperText}
      slotProps={{
        input: {
          endAdornment: !disabled && (
            <InputAdornment position="end">
              <IconButton onClick={handleClick} edge="end">
                <Icon>
                  <FontAwesomeIcon style={{ width: '100%' }} icon={fas.faPencil} />
                </Icon>
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
